import { RequestService } from '../../../../../common/services/RequestService';
import { FUNCTIONS_GET } from '../../constants';

export const getFunctionsRequest = payload => {
  return RequestService.get(FUNCTIONS_GET);
};
